import { render, staticRenderFns } from "./MarketInfo.vue?vue&type=template&id=54338b02&"
import script from "./MarketInfo.vue?vue&type=script&lang=js&"
export * from "./MarketInfo.vue?vue&type=script&lang=js&"
import style0 from "./MarketInfo.vue?vue&type=style&index=0&id=54338b02&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports